// src/onboarding/activation/ActivationFlow.jsx
/**
 * ActivationFlow (Duolingo-like shell)
 * - Top header: close (X), long progress bar, lives
 * - Middle: step title + lesson (chart)
 * - Separator
 * - Bottom: Skip | Continue (Continue disabled until step done)
 */


/**
 * ActivationFlow (Duolingo-like shell)
 * - Top header: close (X), long progress bar, lives
 * - Middle: step title + lesson (chart)
 * - Separator
 * - Bottom: Skip | Continue (Continue disabled until step done)
 */

/**
 * ActivationFlow (Duolingo-like shell)
 * - Top header: close (X), long progress bar, lives
 * - Middle: step title + lesson (chart)
 * - Separator
 * - Bottom: Skip | Continue (Continue disabled until step done)
 */

/**
 * ActivationFlow (Duolingo-like shell)
 * - Top header: close (X), long progress bar, lives
 * - Middle: step title + lesson (chart)
 * - Separator
 * - Bottom: Skip | Continue (Continue disabled until step done)
 */
// src/onboarding/activation/ActivationFlow.jsx
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

// Lessons
import ArrowUpLesson from "./lessons/ArrowUpLesson";
import TrendLineLesson from "./lessons/TrendLineLesson";
import HorizontalLineLesson from "./lessons/HorizontalLineLesson";
import SupportLineLesson from "./lessons/SupportLineLesson";
import ResistanceLineLesson from "./lessons/ResistanceLineLesson";

// AhaMoment Screens
import ProbeScoreLesson from "../aha/ProbeScoreLesson";
import ProbeAskChartLesson from "../aha/ProbeAskChartLesson";

// Scenes
import { scenes } from "./kit/scenes";

const ORANGE = "#FF7C24";
const SCORE_INCREMENT = 0.1;

// ORIGINAL CORE MICRO-TASK LESSONS
const BASE_LESSONS = [
  { key: "arrow-up", title: "Draw the trend line", Component: ArrowUpLesson, candles: scenes.demo },
  // { key: "trend-line", title: "Draw the Trend Line", Component: TrendLineLesson, candles: scenes.demo },
  // { key: "horiz", title: "Place Horizontal Line", Component: HorizontalLineLesson, candles: scenes.demo },
  // { key: "support", title: "Mark Support", Component: SupportLineLesson, candles: scenes.demo },
  // { key: "resistance", title: "Mark Resistance", Component: ResistanceLineLesson, candles: scenes.resistanceJun1to15 },
];

// BUILD FULL FINAL LESSON LIST WITH AHA MOMENT INSERTED
function buildLessonFlow() {
  const full = [];

  for (let i = 0; i < BASE_LESSONS.length; i++) {
    const base = BASE_LESSONS[i];
    const nextScore = (i + 0.1) * SCORE_INCREMENT;

    full.push(base);

    // AhaMoment Screen 1 – Score
    full.push({
      key: `${base.key}-score1`,
      title: "Your Prop Funding Readiness Score",
      Component: (props) => (
        <ProbeScoreLesson
          {...props}
          previousScore={i === 0 ? 0 : i * SCORE_INCREMENT}
          newScore={nextScore}
        />
      ),
    });

    // AhaMoment Screen 2 – Ask the Chart
    full.push({
      key: `${base.key}-ask`,
      title: "Ask AI",
      Component: (props) => (
        <ProbeAskChartLesson {...props} candles={base.candles} />
      ),
    });

    // AhaMoment Screen 3 – Score Boost
    full.push({
      key: `${base.key}-score2`,
      title: "Great! Your Prop funding readiness Score Just Improved",
      Component: (props) => (
        <ProbeScoreLesson
          {...props}
          previousScore={nextScore}
          newScore={nextScore + SCORE_INCREMENT}
        />
      ),
    });
  }

  return full;
}

const LESSONS = buildLessonFlow();

export default function ActivationFlow() {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [stepDone, setStepDone] = useState(false);

  const step = LESSONS[index];
  const isLast = index === LESSONS.length - 1;
  const progressPct = (index / (LESSONS.length - 1)) * 100;

  const handleContinue = () => {
    if (!stepDone) return;
    if (!isLast) setIndex((n) => n + 1);
    else navigate("/onboarding/activation/subscribe");
  };

  const handleSkip = () => {
    if (!isLast) setIndex((n) => n + 1);
    else navigate("/onboarding/activation/subscribe");
  };

  const LessonComp = step.Component;

  return (
    <div style={S.page}>
      {/* Top bar */}
      <header style={S.topbar}>
        <div style={S.headerInner}>
          <button style={S.close} onClick={() => navigate(-1)}>
            ✕
          </button>

          <div style={S.progress}>
            <motion.span
              style={S.progressFill}
              animate={{ width: `${progressPct}%` }}
              transition={{ duration: 0.35, ease: "easeInOut" }}
            />
          </div>

          <div style={S.lives}>
            <span style={S.heart} />
            <span style={{ fontWeight: 800 }}>5</span>
          </div>
        </div>
      </header>

      {/* Stage */}
      <main style={S.stage}>
        <div style={S.stageInner}>
          <h1 style={S.title}>{step.title}</h1>

          <LessonComp
  key={step.key}
  onContinue={() => setStepDone(true)}
  {...(step.candles ? { candles: step.candles } : {})}
/>

          <hr style={S.separator} />

          <div style={S.actions}>
            <button style={{ ...S.btn, ...S.btnGhost }} onClick={handleSkip}>
              Skip
            </button>

            <button
              style={{
                ...S.btn,
                ...S.btnPrimary,
                opacity: stepDone ? 1 : 0.5,
                cursor: stepDone ? "pointer" : "not-allowed",
              }}
              disabled={!stepDone}
              onClick={handleContinue}
            >
              Continue
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

const S = {
  page: { background: "#0B0D11", color: "#fff", minHeight: "100vh" },
  topbar: { display: "flex", justifyContent: "center" },
  headerInner: { display: "flex", alignItems: "center", gap: 12, padding: 12, width: "min(960px, 96%)" },
  close: { width: 38, height: 38, borderRadius: 12, background: "rgba(255,255,255,.04)", border: "1px solid rgba(255,255,255,.1)", cursor: "pointer" },
  progress: { flex: 1, height: 10, borderRadius: 99, background: "rgba(255,255,255,.1)", overflow: "hidden" },
  progressFill: { display: "block", height: "100%", background: `linear-gradient(90deg, ${ORANGE}, #ff9b24)` },
  lives: { display: "flex", alignItems: "center", gap: 8 },
  heart: { width: 18, height: 18, background: "#FF4C4C", transform: "rotate(45deg)", borderRadius: 4 },
  stage: { display: "flex", justifyContent: "center", paddingTop: 20 },
  stageInner: { width: "min(960px, 96%)" },
  title: { marginBottom: 16, fontSize: 24, fontWeight: 800 },
  separator: { height: 4, border: "none", background: "#007BFF", borderRadius: 4, margin: "22px 0" },
  actions: { display: "flex", justifyContent: "space-between" },
  btn: { padding: "14px 22px", fontSize: 16, borderRadius: 16, fontWeight: 800 },
  btnGhost: { background: "transparent", border: "2px solid rgba(255,255,255,.2)", color: "rgba(255,255,255,.9)" },
  btnPrimary: { background: ORANGE, border: "none", color: "#232830" },
};